import { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { UncontrolledPopover } from 'reactstrap'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

import { reinviteCoach } from '../../actions/coachActions'
import { ReactComponent as EllipsisIcon } from '../../assets/images/common/icons/ellipsis-icon.svg'
import CoachContactInfoModal from './CoachContactInfoModal'
import CoachCareerStatsModal from './CoachCareerStatsModal'
import EditCoachAccoladesModal from './EditCoachAccoladesModal'

import classes from './CoachActions.module.scss'

const CoachActions = ({ coach }) => {
  const { t } = useTranslation()
  const [isContactInfoModalOpen, setIsContactInfoModalOpen] = useState(false)
  const [isEditAccoladesModalOpen, setIsEditAccoladesModalOpen] = useState(false)
  const [isCareerStatsModalOpen, setIsCareerStatsModalOpen] = useState(false)
  const [isReinviting, setIsReinviting] = useState(false)

  const handleReinviteCoach = () => {
    setIsReinviting(true)
    reinviteCoach(coach.id)
      .then(() => toast.success(t('coaches.actions.reinvitationSent'), { position: toast.POSITION.TOP_RIGHT }))
      .catch((_error) => {
        if (_error.response?.status === 503) {
          toast.error(t('coaches.actions.reinviteUnavailable'), { position: toast.POSITION.TOP_RIGHT })
        } else {
          const errorMessage = _error.response.data.errors[Object.keys(_error.response.data.errors)[0]][0] ?? t('coaches.common.somethingWentWrong')
          toast.error(errorMessage, { position: toast.POSITION.TOP_RIGHT })
        }
      })
      .finally(() => setIsReinviting(false))
  }

  const handleViewContactInfo = () => {
    setIsContactInfoModalOpen(true)
  }

  const handleEditAccolades = () => {
    setIsEditAccoladesModalOpen(true)
  }

  return (
    <>
      <button
        id={`coach-actions-${coach.id}`}
        className={classNames(classes.coachActionsIcon, 'd-inline-flex', 'align-items-center', 'justify-content-center')}
        aria-label={t('coaches.actions.moreActions')}
      >
        <EllipsisIcon className={classes.icon} />
      </button>

      {!isReinviting && !isContactInfoModalOpen && !isEditAccoladesModalOpen && !isCareerStatsModalOpen && (
        <UncontrolledPopover
          placement='bottom'
          target={`coach-actions-${coach.id}`}
          trigger='legacy'
          popperClassName='popover-style'
        >
          <div className={classNames('d-flex', 'flex-column', classes.coachActions)}>
            {coach.status === 'invited' ? (
              <button onClick={handleReinviteCoach} aria-hidden='true'>
                {t('coaches.actions.reinvite')}
              </button>
            ) : (
              <button onClick={handleEditAccolades} aria-hidden='true'>
                {t('coaches.actions.editAccolades')}
              </button>
            )}
            <button onClick={handleViewContactInfo} aria-hidden='true'>
              {t('coaches.actions.viewContactInformation')}
            </button>
            {coach.status === 'active' && (
              <button onClick={() => setIsCareerStatsModalOpen(true)} aria-hidden='true'>
                {t('coaches.actions.viewCareerStats')}
              </button>
            )}
          </div>
        </UncontrolledPopover>
      )}

      <CoachContactInfoModal
        isOpen={isContactInfoModalOpen}
        onClose={() => setIsContactInfoModalOpen(false)}
        coach={coach}
      />

      {isCareerStatsModalOpen && (
        <CoachCareerStatsModal
          isOpen={isCareerStatsModalOpen}
          onClose={() => setIsCareerStatsModalOpen(false)}
          coach={coach}
        />
      )}

      {isEditAccoladesModalOpen && (
        <EditCoachAccoladesModal
          isOpen={isEditAccoladesModalOpen}
          onClose={() => setIsEditAccoladesModalOpen(false)}
          coach={coach}
        />
      )}
    </>
  )
}

CoachActions.propTypes = {
  coach: PropTypes.shape({
    id: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired,
  }).isRequired,
}

export default CoachActions
